// src/pages/About/scenes/SceneShell.jsx
import { Link, useNavigate } from "react-router-dom";
import cls from "../About.module.scss";
import DialogBubble from "./DialogBubble";
import { nextOf, prevOf } from "../data/map";
import i18n from "@/i18n";

export default function SceneShell({ id, chapter }) {
  const nav = useNavigate();
  const next = nextOf(id);
  const prev = prevOf(id);

  const openChapters = () => {
    // tell JumpMenu to open
    window.dispatchEvent(new CustomEvent("about:toggleJump", { detail: true }));
  };

  return (
    <article className={cls.scene} aria-labelledby={`scene-${id}`}>
      <h2 id={`scene-${id}`} className={`${cls.title}`} data-glow="1">
        {chapter.title}
      </h2>

      {/* Desktop: two columns; Mobile: stacked */}
      <div className={cls.layout}>
        {/* LEFT: Dialogs */}
        <div className={cls.leftCol}>
          <div className={cls.bubbles}>
            {chapter.bubbles?.map((b, i) => (
              <DialogBubble key={i} speaker={b.speaker} text={b.text} />
            ))}
          </div>
        </div>

        {/* RIGHT: Actions */}
        <aside className={cls.rightCol} aria-label="Scene actions">
          {!!chapter.choices?.length && (
            <div className={cls.choices}>
              {chapter.choices.map((c, i) => (
                <Link key={i} to={c.to} className="nu-btn">
                  {c.label}
                </Link>
              ))}
            </div>
          )}

          {/* Desktop helper: quick nav duplicates */}
          <div className={cls.sideNav}>
            <button
              className="nu-btn --ghost"
              onClick={() =>
                prev ? nav(`/about-us/${prev}`) : nav("/about-us")
              }
              disabled={!prev}
            >
              {i18n.t("about.back")}
            </button>
            <button className="nu-btn --ghost" onClick={openChapters}>
              {i18n.t("about.chapters")}
            </button>
            <button
              className="nu-btn is-mr"
              onClick={() =>
                next ? nav(`/about-us/${next}`) : nav("/register")
              }
            >
              {i18n.t("about.next")}
            </button>
          </div>
        </aside>
      </div>

      {/* Mobile sticky nav with center Chapters */}
      <nav className={cls.nav} aria-label="Scene navigation">
        <button
          className="nu-btn --ghost"
          onClick={() => (prev ? nav(`/about-us/${prev}`) : nav("/about-us"))}
          disabled={!prev}
        >
          {i18n.t("about.back")}
        </button>

        <button className="nu-btn --ghost" onClick={openChapters}>
          {i18n.t("about.chapters")}
        </button>

        <button
          className="nu-btn is-mr"
          onClick={() => (next ? nav(`/about-us/${next}`) : nav("/register"))}
        >
          {i18n.t("about.next")}
        </button>
      </nav>
    </article>
  );
}
